import { Component, HostListener, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from './features-common/components/features-base.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends FeaturesBaseComponent implements OnInit {
  title = 'Project Tila';
  showAlert: boolean;
  alert: any;

  constructor() {
    super();
  

  }

  ngOnInit() {

  }

  
  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    // Block F12, Ctrl+Shift+I, Ctrl+Shift+C, Ctrl+U
    if (
      event.key === 'F12' ||
      (event.ctrlKey && event.shiftKey && ['I', 'J', 'C'].includes(event.key.toUpperCase())) ||
      (event.metaKey && event.shiftKey && ['I', 'J', 'C'].includes(event.key.toUpperCase())) || // Handle Mac Command key
      (event.ctrlKey && event.key.toUpperCase() === 'U') ||
      (event.metaKey && event.key.toUpperCase() === 'U') // Handle Mac Command+U
    ){
      event.preventDefault();
    }
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent): void {
    event.preventDefault();
  }
  

  //  throw new Error('Checking throwing error in APP Component')


  
}
